import dayjs from "dayjs";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { allLangs } from "./all-langs";
import {
	type LanguageValue,
	changeLangMessages as messages,
} from "./locales-config";
import type { TFunction } from "i18next";

// ----------------------------------------------------------------------

export function useTranslate(ns?: string) {
	const { t: originalT, i18n } = useTranslation(ns);

	const t = useCallback(
		(...args: Parameters<TFunction>): string => originalT(...args),
		[originalT]
	);

	const currentLang =
		allLangs.find((lang) => lang.value === i18n.resolvedLanguage) ||
		allLangs[0];

	const onChangeLang = useCallback(
		(newLang: LanguageValue) => {
			try {
				const langChangePromise = i18n.changeLanguage(newLang);

				const currentMessages = messages[newLang];

				// For now, just log the messages since we don't have toast component yet
				console.log("Changing language...", currentMessages.loading);

				langChangePromise
					.then(() => {
						console.log("Language changed!", currentMessages.success);
						dayjs.locale(currentLang.adapterLocale);
					})
					.catch(() => {
						console.error("Error changing language!", currentMessages.error);
					});
			} catch (error) {
				console.error(error);
			}
		},
		[currentLang, i18n]
	);

	return {
		t,
		i18n,
		onChangeLang,
		currentLang,
	};
}
